import React, {useState} from 'react';
import useGetPrepaymentAuction from '../../../RregisteredOffersAuction/hooks/useGetPrepaymentSuggestion';
import DotsLoading from 'components/loadings/dotsLoading';

import ChooseAcutionItem from './ChooseAcutionItem';
import ChooseAcutionModals from './ChooseAcutionModals';
import useSaledPost from 'modules/myAdvertisment/hooks/useSaledPost';
import useDeleteAd from 'modules/myAdvertisment/myAdvertisment/deleteModal/deleteForm/hooks/useDeleteAd';
interface ChooseAcutionProps {
  postTypes: string;
  chosedSugestionUser: IChosedSugestionUser;
  is_saled: boolean;

  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const ChooseAcution = ({
  chosedSugestionUser,
  postTypes,
  is_saled,
  setChosedSugestionUser,
}: ChooseAcutionProps) => {
  const [isSendMSGOpen, setIsSendMSGOpen] = useState<boolean>(false);
  const [isOpenModalParticipated, setisOpenModalParticipated] =
    useState<boolean>(false);

  const {data, isLoading} = useGetPrepaymentAuction(
    chosedSugestionUser.guid ? chosedSugestionUser.guid : '',
  );
  const {mutate} = useDeleteAd({
    action: () =>
      setChosedSugestionUser({
        guid: null,
        isDelete: false,
        isOpenModal: false,
        profile: null,
        type: null,
      }),
  });

  const {mutateSaled} = useSaledPost({
    action: () =>
      chosedSugestionUser.isDelete &&
      mutate({
        guid: chosedSugestionUser.guid ? chosedSugestionUser.guid : '',
        delete_reason: 'successful',
        type: 'post',
      }),
  });

  const chossingNoneWinner = () => {
    mutateSaled({
      guid: chosedSugestionUser.guid ? chosedSugestionUser.guid : '',
    });
  };
  return (
    <>
      <div className="w-full">
        <div className="flex w-full items-center justify-between py-3 text-green-1 text-[16px]">
          <div className="pr-3  w-[15%] flex items-center justify-center">
            <button
              className="border-[1px] border-primary bg-white text-primary rounded-lg p-2"
              onClick={() => chossingNoneWinner()}
            >
              هیچکدام
            </button>
          </div>
          <div className="text-gray-6 w-[30%] flex items-center justify-center">
            تاریخ
          </div>
          <div className="text-gray-6 w-[30%]  flex items-center justify-center">
            قیمت
          </div>

          <div className="w-[10%] flex items-center justify-center" />
          <div className="w-[10%] flex items-center justify-center" />
        </div>
      </div>
      <div className="flex flex-col w-full  [&>*:nth-child(odd)]:bg-light-gray overflow-y-auto max-h-[60vh] [&>*:nth-child(even)]:bg-white">
        {isLoading ? (
          <DotsLoading />
        ) : (
          data
            ?.map((item, index) => (
              <ChooseAcutionItem
                isOpenModalParticipated={isOpenModalParticipated}
                key={index}
                index={index}
                chosedSugestionUser={chosedSugestionUser}
                isSendMSGOpen={isSendMSGOpen}
                item={item}
                setisOpenModalParticipated={setisOpenModalParticipated}
                setChosedSugestionUser={setChosedSugestionUser}
                setIsSendMSGOpen={setIsSendMSGOpen}
              />
            ))
            .reverse()
        )}
      </div>
      <ChooseAcutionModals
        is_saled={is_saled}
        chosedSugestionUser={chosedSugestionUser}
        isOpenModalParticipated={isOpenModalParticipated}
        isSendMSGOpen={isSendMSGOpen}
        postTypes={postTypes}
        setChosedSugestionUser={setChosedSugestionUser}
        setIsSendMSGOpen={setIsSendMSGOpen}
        setisOpenModalParticipated={setisOpenModalParticipated}
      />
    </>
  );
};

export default ChooseAcution;
